import { useState } from "react";
import { Icon } from "./Icon";

export type Theme = "dark" | "light";
const KEY = "rai-theme";

/** The saved choice, dark when there is none. index.html applies it before the page draws. */
export function savedTheme(): Theme {
  try { return localStorage.getItem(KEY) === "light" ? "light" : "dark"; } catch { return "dark"; }
}

export function ThemeToggle({ className }: { className?: string }) {
  const [theme, setTheme] = useState<Theme>(() => (document.documentElement.dataset.theme as Theme) || savedTheme());
  const toggle = () => {
    const next: Theme = theme === "dark" ? "light" : "dark";
    document.documentElement.dataset.theme = next;
    try { localStorage.setItem(KEY, next); } catch { /* storage blocked: applies until reload */ }
    setTheme(next);
  };
  return (
    <button type="button" className={`btn btn-ghost btn-icon${className ? ` ${className}` : ""}`}
            aria-label="Dark mode" aria-pressed={theme === "dark"} title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
            onClick={toggle}>
      <Icon name={theme === "dark" ? "moon" : "sun"} />
    </button>
  );
}
